import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Play } from "lucide-react";

const ProductCard = ({ product }) => {
  const videoRef = useRef(null);
  const [isHovering, setIsHovering] = useState(false);

  const firstFile = product.files?.[0]?.file;
  const isVideo = firstFile?.match(/\.(mp4|webm|ogg|mov)$/i);

  const handleMouseEnter = () => {
    setIsHovering(true);
    if (videoRef.current && isVideo) {
      videoRef.current.play().catch((err) => console.log("Play error:", err));
    }
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
    if (videoRef.current && isVideo) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  return (
    <div
      key={product.id}
      className="border bg-white rounded shadow hover:shadow-lg transition relative"
    >
      <Link to={`/product/${product.id}`} state={{ product }} className="block">
        <div
          className="relative h-[200px] w-full rounded overflow-hidden border-b border-[#dcdcdc] p-2"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {isVideo ? (
            <>
              <video
                ref={videoRef}
                src={firstFile}
                className="h-full w-full object-cover"
                muted
                loop
                playsInline
              />
              {!isHovering && (
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30">
                  <div className="bg-white bg-opacity-90 rounded-full p-3">
                    <Play
                      className="w-8 h-8 text-gray-800"
                      fill="currentColor"
                    />
                  </div>
                </div>
              )}
            </>
          ) : (
            <img
              src={firstFile || ""}
              alt={product.name}
              className="h-full w-full object-cover"
            />
          )}
        </div>
        <div className="p-2">
          <h3 className="text-gray-600 text-md line-clamp-2">{product.name}</h3>
          <h5 className="text-gray-800 text-lg font-semibold">
            ${product.base_price}
          </h5>
          <p>
            <span className="font-semibold">Min Order:</span>{" "}
            {product.min_order_quantity}
          </p>
        </div>
      </Link>
    </div>
  );
};
export default ProductCard;
